/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEventId } from '@e180/domain/lib/event/util';
import { getMembershipEmailAddress } from '@e180/domain/lib/membership/util';
import { getUserFirstName, getUserLastName } from '@e180/domain/lib/user/util';

import SupportFormDumb from './SupportFormDumb';
import { sendSupportEmail } from 'src/shared/app/support/action/supportActions';
import {
  showSupportSentNotification,
  showSupportSentErrorNotification,
} from 'src/shared/app/support/action/uiSupportActions';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { faqRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  history: Object,
};

const mapStateToProps = (state: State) => ({
  // Used in `mergeProps` only
  membership: getMembership(state),
  event: getEventSafely(state),
  user: getSelf(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { history }: Props,
): Object => {
  const { event, user, membership } = stateProps;

  return {
    ...stateProps,
    handleSubmit(values: Object) {
      history.push(getRoutePath(faqRoute));

      return dispatch(
        sendSupportEmail(
          getUserFirstName(user),
          getUserLastName(user),
          getMembershipEmailAddress(membership),
          getEventId(event),
          window.navigator.userAgent,
          values,
        ),
      )
        .then(() => {
          dispatch(showSupportSentNotification());
        })
        .catch(() => {
          dispatch(showSupportSentErrorNotification());
        });
    },
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(SupportFormDumb);
